import type { ModuleRow } from '~/pages/backoffice/admin/modules/ModulesList'
import { ScormModuleStatus } from '@zeus/index'
import { Pencil, Play, RefreshCw, Trash2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Button } from '~/components/ui/button'

/**
 * Les actions d'une ligne de module : aperçu et remplacement du contenu (#311)
 * pour un module prêt, renommage, suppression. Sans `onReplace`, `onRename` ni
 * `onDelete`, pas de bouton : le porteur n'en a pas le droit.
 */
function ModuleRowActions({ module, onReplace, onRename, onDelete }: {
  module: ModuleRow
  onReplace?: (module: ModuleRow) => void
  onRename?: (module: ModuleRow) => void
  onDelete?: (module: ModuleRow) => void
}) {
  const { t } = useTranslation()
  const ready = module.status === ScormModuleStatus.READY
  const label = (action: string) => t('common.actionFor', { action, name: module.title })

  return (
    <>
      {ready && (
        <Button variant="ghost" size="icon" asChild aria-label={label(t('modules.preview'))}>
          <Link to={`/scorm/preview/${module.id}`}>
            <Play className="size-4" />
          </Link>
        </Button>
      )}
      {ready && onReplace && (
        <Button variant="ghost" size="icon" onClick={() => onReplace(module)} aria-label={label(t('modules.replace.action'))}>
          <RefreshCw className="size-4" />
        </Button>
      )}
      {onRename && (
        <Button variant="ghost" size="icon" onClick={() => onRename(module)} aria-label={label(t('modules.rename.action'))}>
          <Pencil className="size-4" />
        </Button>
      )}
      {onDelete && (
        <Button variant="ghost" size="icon" onClick={() => onDelete(module)} aria-label={label(t('common.delete'))}>
          <Trash2 className="size-4 text-destructive" />
        </Button>
      )}
    </>
  )
}

export default ModuleRowActions
